import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const getFiles = async () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.files}`);
};

export const uploadFile = async file => {
  const instance = getAxiosInstance();
  return instance.post(`${config.baseUrl}${config.paths.files}`, file);
};

export const downloadFile = () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.files}/know`);
};

export const downloadLearningFile = () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}/learning_file`);
};

export const uploadLearningFileData = () => {
  const instance = getAxiosInstance();
  return instance.post(`${config.baseUrl}/learning_file`);
};

export const uploadLearningFile = ({ url, data }) => {
  const instance = getAxiosInstance();
  return instance.post(url, data, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      "Content-Type": "multipart/form-data"
    }
  });
};

export default {
  getFiles,
  uploadFile,
  downloadFile,
  downloadLearningFile
};
